import React, { useEffect, useState } from 'react'
import { Switch, Avatar, Form, Input, Spin } from 'antd'
import {
    UserOutlined,
    EditOutlined,
    LockOutlined,
    TrophyOutlined,
    PlayCircleOutlined,
    CustomerServiceOutlined,
    QuestionCircleOutlined,
    FileProtectOutlined,
    DeleteOutlined,
    LogoutOutlined,
    RightOutlined,
    FileOutlined,
    DownloadOutlined,
    MessageOutlined,
    TeamOutlined,
    SafetyOutlined
} from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ConfirmationModal from '../../../components/modals/ConfirmationModal.jsx'
import { ForgetOtp2FAApi, LogoutApi, Request2faChangeApi } from '../../../api/request/users.js'
import { Cookies } from "react-cookie";
import toast from 'react-hot-toast'
import { setloggedIn } from '../../../store/Slices/userSlice.js'
import { removeCookies } from '../../../services/Cookies.jsx'
import ModalComponent from '../../../components/modals/ModalComponent.jsx'
import LoadableButton from '../../../components/buttons/LoadableButton.jsx'
import { handleApiError } from '../../../utils/handleApiError.js'

const SettingsMobile = () => {
    const dispatch = useDispatch();
    const cookies = new Cookies();
    const [form] = Form.useForm();
    const [formotp] = Form.useForm()
    const navigate = useNavigate();
    const { userDetails } = useSelector(state => state?.user)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ipAddress, setIpAddress] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [verifyWithOpt, setVerifyWithOpt] = useState(userDetails?.verifyWithOpt);
    const [twoFactorEnabled, setTwoFactorEnabled] = useState(verifyWithOpt)
    const [twoFactorLoading, setTwoFactorLoading] = useState(false);
    const [FormData, setFormData] = useState({ email: "" });
    const [timer, setTimer] = useState(0);
    const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
    const menuItems = [
        {
            id: 'two-factor-auth',
            title: 'Two Factor Authentication',
            icon: <LockOutlined className="text-gray-600" />,
            hasArrow: false
        },
        {
            id: 'change-password',
            title: 'Change Password',
            icon: <LockOutlined className="text-gray-600" />,
            hasArrow: true
        },
        {
            id: 'accounts',
            title: 'Accounts',
            icon: <TrophyOutlined className="text-gray-600" />,
            hasArrow: true
        },
        {
            id: 'reports',
            title: 'Reports',
            icon: <FileOutlined className="text-gray-600" />,
            hasArrow: true
        },
        // {
        //     id: 'messanger',
        //     title: 'Messanger',
        //     icon: <MessageOutlined className="text-gray-600" />,
        //     hasArrow: true
        // },
        {
            id: 'tutorial',
            title: 'Tutorial',
            icon: <PlayCircleOutlined className="text-gray-600" />,
            hasArrow: true
        },
        ...(userDetails?.kycStatus !== 'Approved' ? [{
            id: 'kyc',
            title: 'kyc',
            icon: <SafetyOutlined className="text-gray-600" />,
            hasArrow: true
        }] : []),
        {
            id: 'mt5_download',
            title: 'MT5 Download',
            icon: <DownloadOutlined className="text-gray-600" />,
            hasArrow: true
        },
        // ...(userDetails?.isShowParentTree ? [{
        //     id: 'parent_tree',
        //     title: 'Parent Tree',
        //     icon: <TeamOutlined className="text-gray-600" />,
        //     hasArrow: true
        // }] : []),
        {
            id: 'support',
            title: 'Support',
            icon: <CustomerServiceOutlined className="text-gray-600" />,
            hasArrow: true
        },
        {
            id: 'faqs',
            title: "FAQ's",
            icon: <QuestionCircleOutlined className="text-gray-600" />,
            hasArrow: true
        },
    ]

    const handleMenuClick = (itemId) => {
        switch (itemId) {
            case 'edit-profile':
                navigate('/profile')
                break;
            case 'change-password':
                navigate('/change_password')
                break;
            case 'accounts':
                navigate('/accounts')
                break;
            case 'reports':
                navigate('/reports')
                break;
            case 'leaderboard':
                navigate('/leaderboard')
                break;
            case 'messanger':
                navigate('/inbox')
                break;
            case 'tutorial':
                navigate('/tutorials')
                break;
            case 'mt5_download':
                navigate('/download')
                break;
            case 'kyc':
                navigate('/kyc')
                break;
            case 'parent_tree':
                navigate('/perent_tree')
                break;
            case 'support':
                navigate('/support')
                break;
            case 'faqs':
                navigate('/faq')
                break;
            case 'privacy-policy':
                navigate('/privacy-policy')
                break;
            case 'delete-account':
                navigate('/delete-account')
                break;
            default:
                console.log('Menu item clicked:', itemId);
        }
    }

    const handleLogout = async () => {
        try {
            setIsLoading(true);
            const { data } = await LogoutApi({ ipAddress });
            if (data?.success) {
                toast.success(data?.message);
            }
            localStorage.clear();
            dispatch(setloggedIn(false));
            removeCookies('token');
            navigate('/');
            setIsModalOpen(false);
            setIsLoading(false);
        } catch (err) {
            dispatch(setloggedIn(false));
            removeCookies('token');
            navigate('/');
            setIsModalOpen(false);
            setIsLoading(false);
        }
    }

    const open2FAHandle = async () => {
        setTwoFactorLoading(true);
        setLoading(true);
        const success = await resendOTPHandler(!verifyWithOpt);
        setTwoFactorLoading(false);
        setLoading(false);
        if (success) {
            setFormData({ otp: "" });
            setTimer(120);
            setIsOpen2FAModal(true);
        }
    };

    const resendOTPHandler = async (values) => {
        try {
            const { data } = await Request2faChangeApi(values);
            if (data?.success) {
                toast.success(data?.message);
                return true;
            }
        } catch (err) {
        }
        return false;
    };

    const handleSubmit2FA = async (values) => {
        const { otp } = values;
        if (!otp) {
            toast.error("OTP can not be empty.");
            return;
        }
        try {
            setIsLoading(true);
            let params = {
                userId: userDetails?._id,
                Otp: otp,
                isActiveFlag: !verifyWithOpt,
            };
            const { data } = await ForgetOtp2FAApi(params);
            if (data?.success) {
                toast.success(data?.message);
                const newValue = !verifyWithOpt;
                setVerifyWithOpt(newValue);
                localStorage.setItem("verifyWithOpt", JSON.stringify(newValue));
                formotp.resetFields();
                setIsOpen2FAModal(false);
            }
            setIsLoading(false);
        } catch (error) {
            handleApiError(error);
            setIsLoading(false);
        }
    };

    const formatTime = (timer) => {
        const minutes = Math.floor(timer / 60);
        const remainingSeconds = timer % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        return `${formattedMinutes}:${formattedSeconds}`;
    };
    const onChange = (e) => {
        const newValue = e.target ? e.target.value : e;
        setFormData({ ...FormData, otp: newValue });
    };
    const sharedProps = {
        onChange,
    };

    useEffect(() => {
        setVerifyWithOpt(userDetails?.verifyWithOpt);
    }, [userDetails]);

    return (
        <>
            <div className="min-h-screen">
                {/* User Profile Section */}
                <div className="rounded-lg p-4 mb-6 bg-white">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <Avatar
                                size={64}
                                src={userDetails?.profilePicture || null}
                                icon={!userDetails?.profilePicture && <UserOutlined />}
                                className="bg-gray-400"
                            />
                            <div>
                                <h3 className="text-lg font-bold text-gray-800">
                                    {userDetails?.firstName && userDetails?.lastName
                                        ? `${userDetails.firstName} ${userDetails.lastName}`
                                        : userDetails?.email || 'Daniel Walker'
                                    }
                                </h3>
                            </div>
                        </div>
                        <button
                            className="w-8 h-8 bg-[#E2E8F0] rounded-[10px] transition-colors"
                            onClick={() => handleMenuClick('edit-profile')}
                        >
                            <RightOutlined className="text-[#45556C] text-sm" />
                        </button>
                    </div>
                </div>

                {/* Menu Items */}
                <div className="space-y-3 mb-8">
                    {menuItems.map((item) => (
                        <div
                            key={item.id}
                            className="bg-white rounded-lg p-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors"
                            onClick={() => handleMenuClick(item.id)}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-3">
                                    <div className="h-10 w-10 grid place-items-center bg-[#E2E8F0] rounded-[14px]">
                                        {item.icon}
                                    </div>
                                    <span className="text-gray-800 font-medium">{item.title}</span>
                                </div>
                                {item.id === 'two-factor-auth' && (
                                    <div className="flex items-center space-x-2">
                                        {twoFactorLoading && (
                                            <Spin size="small" />
                                        )}
                                        <Switch
                                            checked={twoFactorEnabled}
                                            onChange={() => { setTwoFactorEnabled(!twoFactorEnabled); open2FAHandle() }}
                                            // className="bg-blue-500"
                                            disabled={twoFactorLoading}
                                        />
                                    </div>
                                )}
                                {item.hasArrow && (
                                    <button
                                        className="w-8 h-8 bg-[#E2E8F0] rounded-[10px] transition-colors"
                                        onClick={() => handleMenuClick('edit-profile')}
                                    >
                                        <RightOutlined className="text-[#45556C] text-sm" />
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Logout Button */}
                <div className="mb-8">
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="w-full bg-primary hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-colors flex items-center justify-center space-x-2"
                    >
                        <LogoutOutlined />
                        <span>Logout</span>
                    </button>
                </div>
            </div>
            {/* --- Logout confirmation modal --- */}
            <ConfirmationModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                message='Are you sure you want to logout?'
                onConfirm={handleLogout}
                isLoading={isLoading}
                loadingLabel='Logging out...'
            />

            <ModalComponent isOpen={isOpen2FAModal} setIsOpen={setIsOpen2FAModal} title='Two Factor Authentication' width={600}>
                <div className='sm:grid grid-cols-12 justify-center items-center '>
                    <div className='md:col-span-12 col-span-5 flex flex-col bg-[#FFFFFF] justify-center items-center px-10 py-10 gap-6  w-full'>

                        <div className="text-center">
                            <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                                A verification code has been sent to your email address: {userDetails?.email}
                            </p>
                            <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
                                Please enter the OTP and verify yourself
                            </p>
                        </div>
                        <div className="w-full">
                            <Form autoComplete="off" form={formotp} onFinish={handleSubmit2FA}>
                                <div className="w-full text-sm py-1">
                                    <div className="relative">
                                        <Form.Item
                                            name="otp"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <Input.OTP
                                                {...sharedProps}
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="my-6 flex justify-center">
                                    {
                                        timer == 0 ? (<button type="button" onClick={open2FAHandle} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<p>Resend OTP in {formatTime(timer)}</p>)
                                    }
                                </div>
                                <div className="mt-8">
                                    <LoadableButton
                                        type='submit'
                                        className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text'
                                        lable='Verify'
                                        isLoading={isLoading}
                                        loadingLable='Verifying...'
                                    />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </>
    )
}

export default SettingsMobile